import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {IndexTemplate} from '@github-ui/swp-core/layouts/contentful/IndexTemplate'
import {DynamicIndexTemplate} from '@github-ui/swp-core/layouts/contentful/DynamicIndexTemplate'
import {toIndexPage} from '@github-ui/swp-core/schemas/contentful/contentTypes/indexTemplate'
import {safeResolveResponse} from '@github-ui/swp-core/lib/utils/contentful'
import {toEntryCollection} from '../../lib/types/contentful'
import {isDynamicIndexPayload, toDynamicIndexPayload, toIndexPayload} from '../../lib/types/payload'

export function IndexPage() {
  const rawPayload = useRoutePayload<unknown>()

  // Check if this is the dynamic resources payload
  if (isDynamicIndexPayload(rawPayload)) {
    const {contentfulRawJsonResponse, filters, resources, additionalProps} = toDynamicIndexPayload(rawPayload)
    // legacyMode is required because contentfulRawJsonResponse is pre-processed by Ruby code,
    // so its shape differs from a raw Contentful API response and breaks with the new resolver.
    const page = toIndexPage(
      toEntryCollection(safeResolveResponse(contentfulRawJsonResponse, {legacyMode: true})).at(0),
    )
    return (
      <DynamicIndexTemplate page={page} filters={filters} resources={resources} additionalProps={additionalProps} />
    )
  }

  // Otherwise, render the manual-based index page
  const {contentfulRawJsonResponse, additionalProps} = toIndexPayload(rawPayload)
  // legacyMode is required because contentfulRawJsonResponse is pre-processed by Ruby code,
  // so its shape differs from a raw Contentful API response and breaks with the new resolver.
  const page = toIndexPage(toEntryCollection(safeResolveResponse(contentfulRawJsonResponse, {legacyMode: true})).at(0))

  return <IndexTemplate page={page} additionalProps={additionalProps} />
}
